import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
})
export class WelcomePage implements OnInit {

  szer = '600px';
  wysoko = '370px';
  ifrejm: any;
  cleanSupportURL;

  constructor(private modalController: ModalController, public sanitizer: DomSanitizer) { }
  
  ngOnInit() {
    this.ifrejm = document.getElementById('ifrejm');

    const ytLink = 'https://www.youtube.com/embed/DmhUbPkIyfc';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(ytLink);
    this.resizeAll();
  }

  dismissIntro()
  {

    this.modalController.dismiss();
  }

  getInnerWidth(elem) {

    let last = parseFloat(window.getComputedStyle(elem).width);
    if (last > 800)
    {
      last = 800;
    }
    return 800;
  }

  resizeAll()
  {
    console.log('resized', this.szer);
    this.ifrejm = document.getElementById('ifrejm');

    // this.wysoko = (this.getInnerWidth(this) * 0.5625) + 'px';
    // this.szer = this.getInnerWidth(this) + 'px';

    if (!this.ifrejm)
    {
      // this.wysoko = (this.getInnerWidth(this) * 0.5625) + 'px';
      // this.szer = this.getInnerWidth(window.document.body) + 'px';
      console.log('resizeAll XXX', this.szer);
    }
    else
    {
      // this.wysoko = (this.getInnerWidth(this) * 0.5625) + 'px';
      // this.szer = this.getInnerWidth(this.ifrejm) + 'px';
      console.log('resizeAll ifrejm', this.szer);
    }
  }

}
